import { render } from "./bestCombinationTable.vue?vue&type=template&id=56607552&scoped=true&ts=true"
import script from "./bestCombinationTable.vue?vue&type=script&lang=ts"
export * from "./bestCombinationTable.vue?vue&type=script&lang=ts"

import "./bestCombinationTable.vue?vue&type=style&index=0&id=56607552&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56607552"]])

export default __exports__